var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMapMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.01,
  d: "M0 0h26v40H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E86F54",
  d: "M0 13C0 5.82 5.82 0 13 0s13 5.82 13 13q0 .114-.002.228c.002 9.12-9.992 13.774-12.314 25.503-.288 1.693-1.047 1.691-1.368 0C9.999 27.001 0 22.345 0 13.347z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#A44B37",
  d: "M13 18c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5"
})));
export default SvgMapMarker;